<template>
	<div>
		<v-tabs grow class="checkin-tabs pos-tabs-left" v-model="activeTab">
			<v-tabs-bar class="transparent">
				<v-tabs-slider class="default-skyblue"></v-tabs-slider>
				<v-tabs-item
					v-for="tab in tabs"
					:key="tab.id"
					:href="`#tab-${tab.id}`"
				>
					{{ tab.title }}
				</v-tabs-item>
			</v-tabs-bar>
			<v-tabs-items>
				<v-tabs-content
					v-for="i in tabs.length"
					:key="i"
					:id="`tab-${i}`"
				>
					<activity-list
						v-if="activeActivitiesTab"
					/>
					<login-user
						v-if="activeLoginTab"
					/>
				</v-tabs-content>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>
<script>
import ActivityList from './ActivityList';
import LoginUser from './LoginUser';

function activeActivitiesTab() {
	return this.activeTab === 'tab-2';
}

function activeLoginTab() {
	return this.activeTab === 'tab-1';
}

function data() {
	return {
		activeTab: 'tab-1',
		tabs: [
			{ id: 1, title: 'Log-in' },
			{ id: 2, title: 'Actividades' },
		],
	};
}

export default {
	name: 'activities',
	components: {
		ActivityList,
		LoginUser,
	},
	computed: {
		activeActivitiesTab,
		activeLoginTab,
	},
	data,
};
</script>




// WEBPACK FOOTER //
// Activities.vue?1c0674de